module.exports = __webpack_public_path__ + "img/cloud-snowing-01.a03b3255.svg";